import PropTypes from 'prop-types';
import styles from './FJImageManipulationInput.module.less';
import ReUploadIcon from '../../../assets/svg/re-upload.svg?react';
import UploadIcon from '../../../assets/svg/upload.svg?react';
import AddFileIcon from '../../../assets/svg/add-file.svg?react';
import AddFileWhiteIcon from '../../../assets/svg/add-file-white.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip';
import { useRef } from 'react';
import FJPreviewBox from '../../../common/components/FJPreviewBox/FJPreviewBox';
import { UPLOAD_FILE_TYPE_NO_GIF } from '../../../config/dataConfig/FJGenerateData';

const FJImageManipulationInput = props => {
    const {
        isDraggingFile,
        uploadImageInfo = {},
        uploadImg,
        setIsDraggingFile,
        disableUpload,
        openMediaLibrary,
    } = props;
    const { src: imgSrc, width, height } = uploadImageInfo;
    const inputRef = useRef(null);
    const _onUploadImg = e => {
        if (disableUpload) return;
        const file = e.target.files[0];
        uploadImg(file);
        e.target.value = null;
    };
    const _onUpload = () => {
        if (disableUpload) return;
        if (window.isEditPage && openMediaLibrary) openMediaLibrary();
        else if (inputRef.current) {
            inputRef.current.click();
        }
    };
    const _onDragOver = e => {
        if (disableUpload) return;
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(true);
    };

    const _onDragLeave = e => {
        if (disableUpload) return;
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
    };

    const _onDragDrop = e => {
        if (disableUpload) return;
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            uploadImg(file);
        }
    };
    const imgInfo = imgSrc && `${width} * ${height} px`;

    return (
        <div
            className={classNames(styles.input_box, { [styles.disabled]: disableUpload })}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
        >
            {imgSrc ? (
                <div className={styles.img_content}>
                    <div className={styles.img_box}>
                        <img className={styles.img} src={imgSrc} alt='' loading='lazy' />
                        <FJPreviewBox imageInfo={uploadImageInfo} className={styles.mask} />
                    </div>
                    <div className={styles.img_info}>
                        <span className={styles.img_info_title}>{FJLocalStore._('image')}</span>
                        <span className={styles.img_info_text}>{imgInfo}</span>
                    </div>
                    <FJToolTip title={FJLocalStore._('change-image')}>
                        <div className={styles.reload_icon} onClick={_onUpload}>
                            <ReUploadIcon />
                        </div>
                    </FJToolTip>
                </div>
            ) : (
                <div className={styles.blank} onClick={_onUpload}>
                    {isDraggingFile ? <AddFileIcon /> : <UploadIcon />}
                    <span className={styles.blank_text}>{FJLocalStore._('upload-image')}</span>
                </div>
            )}

            {isDraggingFile && (
                <div className={classNames(styles.filter_mask, isDraggingFile ? styles.dragging : '')}>
                    <AddFileWhiteIcon />
                    <span className={styles.filter_mask_text}>{FJLocalStore._('drag-and-drop')}</span>
                </div>
            )}

            <div className={styles.dragging_mask}></div>

            <input
                type='file'
                ref={inputRef}
                className={styles.file_input}
                accept={UPLOAD_FILE_TYPE_NO_GIF}
                onChange={_onUploadImg}
            />
        </div>
    );
};
FJImageManipulationInput.propTypes = {
    uploadImageInfo: PropTypes.object,
    openMediaLibrary: PropTypes.func,
    uploadImg: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    disableUpload: PropTypes.bool,
};
export default FJImageManipulationInput;
